/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Option,
    OptionFromJSON,
    OptionFromJSONTyped,
    OptionToJSON,
} from './';

/**
 * 
 * @export
 * @interface OptionGroup
 */
export interface OptionGroup {
    /**
     * 
     * @type {number}
     * @memberof OptionGroup
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OptionGroup
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OptionGroup
     */
    nameJa: string;
    /**
     * 
     * @type {Array<Option>}
     * @memberof OptionGroup
     */
    options: Array<Option>;
}

export function OptionGroupFromJSON(json: any): OptionGroup {
    return OptionGroupFromJSONTyped(json, false);
}

export function OptionGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): OptionGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'nameJa': json['nameJa'],
        'options': ((json['options'] as Array<any>).map(OptionFromJSON)),
    };
}

export function OptionGroupToJSON(value?: OptionGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'nameJa': value.nameJa,
        'options': ((value.options as Array<any>).map(OptionToJSON)),
    };
}


